import { INgsiIdDesignPattern } from '../helpers/ngsild.constants'
import {
  IMapWidgetFormGroupSettings
} from '../../../map-widget-settings/map-widget-settings.interface'
import { INgsiEntity } from '../interfaces/ngsi-entity.interface'
import { INgsiMaritimeTargets } from '../interfaces/ngsi-maritime-targets.interface'
import { ILeafletInstance } from '../../leaflet/leaflet.interface'
import { MarkerService } from '../../leaflet/markers/marker.service'
import * as AisTrackSymbol from '../../leaflet/markers/leaflet-tracksymbol2/ais-track-symbol'
import * as NgsiAIS from '../../ngsild/models/ngsi-ais'
import * as DivIcons from '../../leaflet/markers/div-icons/div-icons-constant'
import { PopupService } from '../../leaflet/popup/popup.service'
import { TooltipService } from '../../leaflet/tooltips/tooltip.service'
import { IMapWidgetPermissions } from '../../../../shared/interfaces/map-widget-permission.interface'
import { INotification } from 'ngsild-connector'
import * as leafletInstanceConfig from '../helpers/leaflet-instance-config.constants'

export const entityType: string = `MaritimeTargets`
export const maritimeTargetsOwner: string = 'CAPTN'

export const ngsiMaritimeTargetsIdPattern: Omit<INgsiIdDesignPattern, 'idPattern'> = {
  prefix: `urn:ngsi-ld:`,
  type: entityType,
  owner: maritimeTargetsOwner
}

export const allowDisplayOfEntity = (
  settings: IMapWidgetFormGroupSettings,
  entity: INgsiEntity
): boolean => {
  return entity.type === entityType && settings.enableMaritimeTargets;
}

export const filterOnMaritimeObjectDetection = (
  notification: INotification,
  appPluginWidgetSettings: IMapWidgetFormGroupSettings,
  widgetPermissions: IMapWidgetPermissions
): boolean => {
  const settings = appPluginWidgetSettings
  if (settings?.entities) {
    return widgetPermissions.maritimeTargetsDataEnabled &&
      allowDisplayOfEntity(settings, notification.data[0]);
  } else {
    return false;
  }
}

export const createMarker = (
  entity: INgsiMaritimeTargets,
  settings: IMapWidgetFormGroupSettings,
  instance: ILeafletInstance,
  popupService: PopupService,
  tooltipService: TooltipService,
  markerService: MarkerService
) => {
  switch (entity.source) {
    case leafletInstanceConfig.config.dataModel.MaritimeTargets.dataSources[0]['IN_TTD']:
    case leafletInstanceConfig.config.dataModel.MaritimeTargets.dataSources[1]['IN_TLLAIS']: {
      if (entity.source === leafletInstanceConfig.config.dataModel.MaritimeTargets.dataSources[1]['IN_TLLAIS']) {
        entity.shipType = 103
      } else {
        entity.shipType = 101;
      }

      const trackerDetails = AisTrackSymbol.createMarker(entity.id, instance);
      if (trackerDetails?.marker) {
        popupService.bindPopupOnce(trackerDetails.marker, entity, settings, instance, popupService, trackerDetails)
        tooltipService.bindTooltipOnce(trackerDetails?.marker, entity,  instance.dataConfig.globale.showPermanentTooltip);
      }

      return trackerDetails?.marker;
    }
    case leafletInstanceConfig.config.dataModel.MaritimeTargets.dataSources[2]['SF_CAM']: {
      const trackerDetails = markerService.createDivIconMarkerContent(entity, settings, instance, DivIcons.orangeDivCircle);
      if (trackerDetails?.marker) {
        popupService.bindPopupOnce(trackerDetails.marker, entity, settings, instance, popupService, trackerDetails)
        tooltipService.bindTooltipOnce(trackerDetails?.marker, entity,  instance.dataConfig.globale.showPermanentTooltip);
      }

      return trackerDetails?.marker
    }
    default:
      return undefined;
  }
}

export const updateMarker = (
  entity: INgsiMaritimeTargets,
  marker: L.Marker<any>,
  settings: IMapWidgetFormGroupSettings,
  instance: ILeafletInstance,
  popupService: PopupService,
  tooltipService: TooltipService,
  markerService: MarkerService
) => {
  if (entity.source === leafletInstanceConfig.config.dataModel.MaritimeTargets.dataSources[1]['IN_TLLAIS'] ||
      entity.source === leafletInstanceConfig.config.dataModel.MaritimeTargets.dataSources[0]['IN_TTD']) {
    if (entity.source === leafletInstanceConfig.config.dataModel.MaritimeTargets.dataSources[1]['IN_TLLAIS']) {
      entity.shipType = 103
    } else {
      entity.shipType = 101;
    }
    NgsiAIS.updateAISMarkerPosition(entity, marker, settings, instance, markerService.popupService, tooltipService);
  }

  if (entity.source === leafletInstanceConfig.config.dataModel.MaritimeTargets.dataSources[2]['SF_CAM']) {
    const trackerDetails = markerService.updateDivIconMarkerContent(entity, marker, settings, instance)
    if (trackerDetails?.marker) {
      popupService.bindPopupOnce(trackerDetails.marker, entity, settings, instance, popupService, trackerDetails)
      tooltipService.updateTooltipContent(entity, trackerDetails.marker);
    }
  }
}
